import { Field, useForm } from "react-final-form";
import { useIntl } from "react-intl";
import { DatePicker, DropdownInput, TextInput, TextAreaInput } from "../fields";
import { useEffect } from "react";

const FormBuilder = ({ fields, disabled, initialValues }) => {
  const intl = useIntl();
  const form = useForm();

  useEffect(() => {
    if (disabled) {
      Object.keys(initialValues).forEach((key) => {
        form.change(key, initialValues[key]);
      });
    }
  }, [disabled, form, initialValues]);

  return (
    <div className="grid gap-4">
      {fields.map((field) => {
        return (
          <div
            className={
              field.type.toLowerCase() === "textlong"
                ? "col-12"
                : "col-12 md:col-5 lg:col-5"
            }
            key={field.label}
          >
            {((field.type.toLowerCase() === "text" ||
              field.type.toLowerCase() === "number") && (
              <Field
                name={field.name || field.label}
                component={TextInput}
                type={field.type}
                required={field.isRequired}
                readOnly={field.readOnly}
                disabled={disabled}
                placeholder={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
                label={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
              />
            )) ||
              null}
            {(field.type.toLowerCase() === "textlong" && (
              <Field
                name={field.name || field.label}
                component={TextAreaInput}
                required={field.isRequired}
                readOnly={field.readOnly}
                disabled={disabled}
                maxLength={field.maxLength}
                placeholder={
                  field.placeholder ||
                  (field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label)
                }
                label={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
              />
            )) ||
              null}
            {((field.type.toLowerCase() === "dropdown" ||
              field.type.toLowerCase() === "boolean") && (
              <Field
                name={field.name || field.label}
                component={DropdownInput}
                required={field.isRequired}
                readOnly={field.readOnly}
                disabled={disabled}
                editable={field.editable || false}
                options={field.options || []}
                // A field that searches the server (the user details manager)
                filter={field.filter || false}
                onFilter={field.onFilter}
                placeholder={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
                label={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
              />
            )) ||
              null}
            {(field.type.toLowerCase() === "date" && (
              <Field
                name={field.name || field.label}
                component={DatePicker}
                required={field.isRequired}
                readOnly={field.readOnly}
                disabled={disabled}
                // Past dates (for example a date of birth): no minimum, up to today
                minDate={null}
                maxDate={new Date()}
                placeholder={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
                label={
                  field.i18n
                    ? intl.formatMessage({ id: field.label })
                    : field.label
                }
              />
            )) ||
              null}
          </div>
        );
      })}
    </div>
  );
};

export default FormBuilder;
